import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { jsx as t, jsxs as c } from "react/jsx-runtime";
import p from "classnames";
import N from "../../assets/icons/chevron-down-mobile.svg.js";
import * as s from "@radix-ui/react-accordion";
import m from "../Link/Link.js";
import o from "./NavMenuContent.module.scss.js";
var L = function L(_ref) {
  var d = _ref.content,
    g = _ref.collapsible;
  return /* @__PURE__ */t("div", {
    className: o.row,
    children: d.linksSection.map(function (i) {
      return /* @__PURE__ */t("div", {
        className: "".concat(o.sectionContainer, " ").concat(o.linksListContainer),
        children: g ? /* @__PURE__ */t(s.Root, {
          className: o.accordionRoot,
          type: "single",
          collapsible: !0,
          children: i.links.map(function (e) {
            var _ref2;
            var r, l, n;
            return /* @__PURE__ */c(s.Item, {
              className: o.accordionItem,
              value: (_ref2 = (r = e.text) == null ? void 0 : r.toString()) !== null && _ref2 !== void 0 ? _ref2 : "",
              children: [/* @__PURE__ */c(s.Trigger, {
                className: o.accordionTrigger,
                children: [e.text, /* @__PURE__ */t(N, {
                  className: o.accordionChevron
                })]
              }), /* @__PURE__ */t(s.Content, {
                className: o.accordionContent,
                children: (l = e.subLinks) == null ? void 0 : l.map(function (a, h) {
                  return /* @__PURE__ */t(m, {
                    onClick: a.onClick,
                    href: a.url,
                    className: o.subLink,
                    target: a.target,
                    children: a.text
                  }, "subLink-".concat(h));
                })
              })]
            }, (n = e.text) == null ? void 0 : n.toString());
          })
        }) : /* @__PURE__ */t("ul", {
          className: "".concat(o.linksList),
          children: i.links.map(function (e) {
            var _e$as;
            var r;
            return /* @__PURE__ */t("li", {
              className: p(o.linkListItem, _defineProperty({}, o.withLogo, e.logo)),
              children: /* @__PURE__ */c(m, {
                as: (_e$as = e.as) !== null && _e$as !== void 0 ? _e$as : "a",
                onClick: e.onClick,
                href: e.url,
                className: o.link,
                target: e.target,
                children: [e.logo && /* @__PURE__ */t("span", {
                  className: o.linkLogo,
                  children: e.logo
                }), e.text]
              })
            }, (r = e.text) == null ? void 0 : r.toString());
          })
        })
      }, i.title);
    })
  });
};
export { L as default };